"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokenAddressException = void 0;
const http_exception_1 = require("../http.exception");
class BrokenAddressException extends http_exception_1.HttpException {
    constructor(reason) {
        super(501, `Broken address: ${reason}`);
    }
}
exports.BrokenAddressException = BrokenAddressException;
//# sourceMappingURL=brokenAddress.exception.js.map